import React, { useState } from "react";
import Header from "../components/Admin/header/Header";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import {
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  Container,
  FormControl,
  Grid,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  OutlinedInput,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useNavigate } from "react-router-dom";

export default function PathologyDrApproval() {
  const navigate = useNavigate();
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: "flex" }}>
        <Box sx={{}}>
          <Sidebar />
        </Box>
        <Box sx={{ width: "100%" }}>
          {/*Pathology add report details */}
          <Tooltip title="Back to previous page" onClick={() => navigate(-1)}>
            <IconButton
              sx={{ paddingTop: 2, paddingBottom: 2, marginLeft: -2 }}
            >
              <KeyboardArrowLeftIcon />
              <Typography>Back</Typography>
            </IconButton>
          </Tooltip>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              marginRight: "90px",
            }}
          >
            <Typography
              variant="subtitle1"
              color="#5D6A82"
              paddingTop={2}
              paddingBottom={2}
            >
              Doctor Approval Report
            </Typography>

            {/* right end close button  */}
            <Tooltip title="close">
              <IconButton>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>

          {/* basic information box */}
          <Box
            sx={{
              // paddingTop: "20px",
              // width: "100%",
              marginBottom: "20px",
              marginRight: "90px",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              paddingInline: "15px",
            }}
          >
            <Typography
              sx={{
                fontSize: 14,
                paddingLeft: 2,
                paddingTop: 2,
                paddingBottom: 2,
              }}
            >
              {" "}
              Basic Information
            </Typography>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-evenly",
                paddingBottom: "20px",
              }}
              container
              spacing={2}
            >
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Sample ID"
                  sx={{ backgroundColor: "#F4F6F7" }}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-name-label">
                    Machine Name
                  </InputLabel>
                  <Select
                    sx={{ backgroundColor: "#F4F6F7" }}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    input={<OutlinedInput label="Machine Name" />}
                  >
                    <MenuItem value="dummy1">dummy1</MenuItem>
                    <MenuItem value="dummy2">dummy2</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-name-label">
                    Fetched By
                  </InputLabel>
                  <Select
                    sx={{ backgroundColor: "#F4F6F7" }}
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    input={<OutlinedInput label="Fetched By" />}
                  >
                    <MenuItem value="dummy1">dummy1</MenuItem>
                    <MenuItem value="dummy2">dummy2</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {/* checkBox */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              marginLeft: -1.5,
              marginBottom: 2,
            }}
          >
            <Checkbox />
            <Typography>Select All Report</Typography>
          </Box>

          {/* detailed report form  */}
          <Box
            sx={{
              // paddingTop: "20px",
              // width: "100%",
              marginBottom: "20px",
              marginRight: "90px",
              backgroundColor: "#F0F7FC",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              paddingInline: "15px",
            }}
          >
            <Typography
              variant="subtitle1"
              color="#5D6A82"
              paddingTop={2}
              paddingBottom={2}
            >
              Complete Blood Count (CBC)
            </Typography>
            <Grid
              container
              spacing={3}
              sx={{ paddingLeft: 2, paddingBottom: 2 }}
            >
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Hemoglobin "
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography align="">gm/dL</Typography>
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>12-18</Typography>
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox />
                <Typography>Not Required</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{ paddingLeft: 2, paddingBottom: 2 }}
            >
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Hematocrit "
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography align="">%</Typography>
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>42-52</Typography>
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox />
                <Typography>Not Required</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{ paddingLeft: 2, paddingBottom: 2 }}
            >
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="RBC Count "
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography align="">milli/cmm</Typography>
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>4.6-6.2</Typography>
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox />
                <Typography>Not Required</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={3}
              sx={{ paddingLeft: 2, paddingBottom: 2 }}
            >
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="MCV "
                  sx={{ backgroundColor: "white" }}
                />
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography align="">fl</Typography>
              </Grid>
              <Grid item xs={1} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>78-98</Typography>
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <Checkbox />
                <Typography>Not Required</Typography>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginBottom: 6,
              gap: 4,
            }}
          >
            <Button variant="outlined" sx={{ width: "200px" }}>
              Print Preview
            </Button>
            <Button variant="contained" sx={{ width: "200px" }}>
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
